module.exports = " <div class=\"add-league level\"> <input v-model=league.en.title type=text placeholder=\"League title\" class=input /> <input v-model=league.en.subtitle type=text placeholder=Subtitle class=input /> <button v-on:click=add class=\"button is-primary\"> Add new league </button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeagueAdd.vue
 ** module id = 48
 ** module chunks = 1
 **/